import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  EldMovement,
  FetchMovementsPayload,
  CreateMovementPayload,
  UpdateMovementPayload,
  MovementClaimPayload,
  MovementsActionPayload,
  FetchMovementAssignmentsPayload,
  MovementAssignment,
  ProposedTrip,
  ClaimMovementsPayload,
} from 'src/common/types';

export interface MovementState {
  [key: string]: EldMovement[] | ProposedTrip[];
}
const initialState: MovementState = {};

export interface ProposedMovementState {
  Proposed: MovementAssignment[];
}

export const fetchUnassignedMovements = createAction<FetchMovementsPayload>(
  'movements/fetchUnassignedMovements',
);
export const fetchProposedMovements = createAction<FetchMovementAssignmentsPayload>(
  'movements/fetchProposedMovements',
);

export const claimMovements = createAction<CreateMovementPayload>('movements/claimMovements');
export const rejectMovements = createAction<UpdateMovementPayload>('movements/rejectMovements');
export const acceptMovements = createAction<UpdateMovementPayload>('movements/acceptMovements');

export const reducerSlice = createSlice({
  name: 'movementsReducer',
  initialState,
  reducers: {
    setMovements: (state, action: PayloadAction<MovementsActionPayload>): void => {
      state[action.payload.type] = action.payload.movements;
    },
    setMovementClaimed: (state, action: PayloadAction<MovementClaimPayload>): void => {
      const movement = state[action.payload.type].find(
        movement => movement.movementId === action.payload.movementId,
      );
      if (movement) {
        movement.claimed = true;
      }
    },
    setAllMovementsClaimed: (state, action: PayloadAction<ClaimMovementsPayload>): void => {
      state[action.payload.status]
        .filter(movement => action.payload.movementIds.includes(movement.movementId))
        .forEach(movement => {
          movement.claimed = true;
        });
    },
    setMovementRejected: (state, action: PayloadAction<MovementClaimPayload>): void => {
      const movement = state[action.payload.type].find(
        movement => movement.movementId === action.payload.movementId,
      );
      if (movement) {
        movement.rejected = true;
      }
    },
    setAllMovementsRejected: (state, action: PayloadAction<ClaimMovementsPayload>): void => {
      state[action.payload.status]
        .filter(movement => action.payload.movementIds.includes(movement.movementId))
        .forEach(movement => {
          movement.rejected = true;
        });
    },
  },
});

export const {
  setMovements,
  setMovementClaimed,
  setAllMovementsClaimed,
  setMovementRejected,
  setAllMovementsRejected,
} = reducerSlice.actions;

export default reducerSlice.reducer;
